import * as logger from 'loglevel';
import dayjs from 'dayjs';
import useParameterEvaluator from './useParameterEvaluator';

/**
 * Build query for deeplink
 */
export default (container, fare, origin, destination) => {
  const {
    prePopulation,
    pageContext,
    integrationSettings: {
      v2DeepLinkApiSettings: { params }
    }
  } = container;

  // Get external platfom parameters
  const { deviceCategory, siteEdition } = pageContext;
  const { travelClass, flexibleDates, promoCode, extraInfo } = params;

  if (!deviceCategory) {
    logger.warn('INTEGRATION__DEEPLINK: **device** is not defined.');
  }
  if (!siteEdition) {
    logger.warn('INTEGRATION__DEEPLINK: **siteEdition** is not defined.');
  }
  if (!travelClass) {
    logger.warn('INTEGRATION__DEEPLINK: **travelClass** is not defined.');
  }
  if (promoCode === null) {
    logger.warn('INTEGRATION__DEEPLINK: **promoCode** is not defined.');
  }
  if (!extraInfo) {
    logger.warn('INTEGRATION__DEEPLINK: **extraInfo** is not defined.');
  }

  if (!fare) {
    logger.warn('INTEGRATION__DEEPLINK: **fare** is empty.');
  }

  const query = {
    origin: (fare && fare.origin) || origin || '',
    destination: (fare && fare.destination) || destination || '',
    departure: fare && dayjs(fare.departureDate).format('YYYY-MM-DD'),
    return:
      fare && prePopulation.flightType === 'ROUND_TRIP'
        ? dayjs(fare.returnDate).format('YYYY-MM-DD')
        : '',
    flightType: prePopulation && prePopulation.flightType,
    siteEdition,
    language: prePopulation && prePopulation.languageCode,
    passengers: {
      passenger1: 1
    },
    currencyCode: (fare && fare.currencyCode) || '',
    travelClass: fare && useParameterEvaluator(fare, travelClass),
    promoCode: fare && useParameterEvaluator(fare, promoCode),
    flexibleDates: fare && useParameterEvaluator(fare, flexibleDates),
    device: (deviceCategory && deviceCategory.toUpperCase()) || 'DESKTOP',
    extraInfo
  };

  return query;
};
